/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_speed_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's a simple way to remember the m/s to km/h conversion?`)
};

const es_uc_speed_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es una manera simple de recordar la conversión m/s a km/h?`)
};

const de_uc_speed_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie merkt man sich einfach die Umrechnung von m/s in km/h?`)
};

const nl_uc_speed_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een eenvoudige manier om de m/s naar km/u conversie te onthouden?`)
};

const fr_uc_speed_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel est un moyen simple de se souvenir de la conversion m/s à km/h ?`)
};

const it_uc_speed_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è un modo semplice per ricordare la conversione m/s a km/h?`)
};

const pt_br2_uc_speed_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é uma maneira simples de lembrar a conversão de m/s para km/h?`)
};

const pt_uc_speed_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é uma forma simples de lembrar a conversão m/s para km/h?`)
};

const ja_uc_speed_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m/s から km/h への変換を覚えておくシンプルな方法は何ですか?`)
};

const zh_uc_speed_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_speed_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_speed_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_speed_faq4_q", locale)
	if (locale === "en") return en_uc_speed_faq4_q(inputs)
	if (locale === "es") return es_uc_speed_faq4_q(inputs)
	if (locale === "de") return de_uc_speed_faq4_q(inputs)
	if (locale === "nl") return nl_uc_speed_faq4_q(inputs)
	if (locale === "fr") return fr_uc_speed_faq4_q(inputs)
	if (locale === "it") return it_uc_speed_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_speed_faq4_q(inputs)
	if (locale === "pt") return pt_uc_speed_faq4_q(inputs)
	if (locale === "ja") return ja_uc_speed_faq4_q(inputs)
	return zh_uc_speed_faq4_q(inputs)
};